import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-lg border border-[#DCE0E7] bg-white px-3 py-2 text-sm text-[#090808] shadow-sm placeholder:text-[#A0A3A8] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/10 focus-visible:border-[#A0A3A8] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
